var MatchesTable = function() {

    const COUPON_VISIBLE_ROWS_THRESHOLD = 10; // threshold of min visible rows to allow "coupon" view

    var hideLeagueHeadersWithoutShownMatches = function() {
        $('table.ii__livescores').each(function() {
            var active_tours = {};
            $(this).find('.ii__match_row').each(function() {
                if ($(this).hasClass('invisible')) {
                    return;
                }
                var cl = $(this).attr('class');
                if (!cl) {
                    return;
                }
                cl = cl.split(' ');
                for (var ix in cl) {
                    if (cl[ix] && Generic.startsWith(cl[ix], 'ii__tour-')) {
                        active_tours[cl[ix]] = 1;
                        return;
                    }
                }
            });
            $(this).find('.ii__tourheader').each(function() {
                var cl = $(this).attr('class');
                if (!cl) {
                    $(this).addClass('invisible');
                    return;
                }
                cl = cl.split(' ');
                for (var ix in cl) {
                    if (cl[ix] && Generic.startsWith(cl[ix], 'ii__tour-')) {
                        if (active_tours[cl[ix]] == undefined) {
                            $(this).addClass('invisible');
                        } else {
                            $(this).removeClass('invisible');
                        }
                    }
                }
            });
        });
    };

    var loadFavsFromCookie = function() {
        if (!Generic.loggedin && Generic.jsCookies.hasItem('fav_matches')) {
            var favs = JSON.parse(Generic.jsCookies.getItem('fav_matches'));
            for (var ix in favs) {
                MatchesTable.favs[favs[ix]] = 1;
            }
        }
        if (!Generic.loggedin) {
            if (Generic.jsCookies.hasItem('pinned_leagues2')) {
                var pinned = JSON.parse(Generic.jsCookies.getItem('pinned_leagues2'));
                for (var iy in pinned) {
                    MatchesTable.pinned[pinned[iy]] = 1;
                }
            } else {
                MatchesTable.pinned = {};
                for (var ik in Generic.default_pinned_leagues) {
                    MatchesTable.pinned[Generic.default_pinned_leagues[ik]] = 1;
                }
            }
        }
        if (!Generic.loggedin && Generic.jsCookies.hasItem('leagues_visibility2')) {
            var leagues_visibility = JSON.parse(Generic.jsCookies.getItem('leagues_visibility2'));
            for (var iz in leagues_visibility) {
                if (leagues_visibility.hasOwnProperty(iz)) {
                    MatchesTable.leagues_visibility[iz] = leagues_visibility[iz];
                }
            }
        }
    };

    return {
        init_match_filter: function(filter_matches_cb) {
            $('#matchfilter').keyup(function(e){
                filter_matches_cb(MatchesTable.match_filter);
            });
        },
        extract_text_from_table_row: function(row) {
            return row.data('search');
        },
        store_match_ordering: function(ord) {
            if (ord == 'byleague') {
                MatchesTable.byleague = 1;
            } else {
                MatchesTable.byleague = 0;
            }
            Ajax.savePrefGrouping(MatchesTable.byleague);
        },
        set_default_view: function(state) {
            if (state === 1) {
                // all
                MatchesTable.default_view = 1;
                $('.ii__dv_all').addClass('active blue');
                $('.ii__dv_coupon').removeClass('active blue');
            } else {
                // coupon
                MatchesTable.default_view = 0;
                $('.ii__dv_all').removeClass('active blue');
                $('.ii__dv_coupon').addClass('active blue');
            }
            MatchesTable.filterMatches(MatchesTable.match_filter);
            Ajax.savePrefDefaultView(MatchesTable.default_view);
        },
        filterMatches: function(status) {
            MatchesTable.match_filter = status;
            var shown = [];

            // no button us active
            $('.ii__mf_btn').removeClass('active');

            if (MatchesTable.default_view === 0) {
                // coupon mode: only show rows with `.ii__has_odds`
                // this works alongside other state modes: live, fin, sched etc
                $('.ii__match_row:not(.ii__has_odds)').addClass('invisible');
                $('.ii__match_row.ii__has_odds').removeClass('invisible');
            }

            if (status == 'fav') {
                // fav mode: only show rows with `.favved` (a class added only in JavaScript)
                $('.ii__mf_btn_fav').addClass('active');
                $('.ii__match_row:not(.favved)').addClass('invisible');
                $('.ii__match_row.favved').removeClass('invisible');
            } else {
                // we'll show & hide rows based on specific match states
                if (status == 'recent') {
                    shown = [2, 3, 7, 100];
                    $('.ii__mf_btn_live').addClass('active');
                } else if (status == 'live') {
                    shown = [2, 3, 7];
                    $('.ii__mf_btn_live').addClass('active');
                } else if (status == 'fin') {
                    shown = [4];
                    $('.ii__mf_btn_fin').addClass('active');
                } else if (status == 'sched') {
                    shown = [1];
                    $('.ii__mf_btn_sched').addClass('active');
                } else {
                    shown = [1, 2, 3, 4, 5, 6, 7];
                    $('.ii__mf_btn_all').addClass('active');
                    MatchesTable.match_filter = 'all';
                }

                $('table.ii__livescores tr.ii__mf_noresults').remove();
                for (var i = 1; i <= 7; i++) {
                    var s = 'table.ii__livescores tr.ii__match_state_' + i;
                    if (MatchesTable.default_view === 0) {
                        s += '.ii__has_odds';
                    }
                    if (shown.indexOf(i) >= 0) {
                        $(s).removeClass('invisible');
                    } else {
                        $(s).addClass('invisible');
                    }
                }

                // Handle mode `recent`. This can include various match states (finished, scheduled and live)
                if (shown.indexOf(100) >= 0) {
                    $('table.ii__livescores tr.ii__match_state_100').removeClass('invisible');
                }
            }

            // handle filtering by typing some letters
            var query = $('#matchfilter').val().toLowerCase().trim();
            // *** IMPORTANT NOTE: Any change here should be mirrored Util::simplified_transliterate()
            var replace_dict = {
                'ου': 'ou', 'ού': 'ou', 'όυ': 'ou', 'α': 'a', 'β': 'b', 'γ': 'g',
                'δ': 'd', 'ε': 'e', 'ζ': 'z', 'η': 'i', 'θ': 'th', 'ι': 'i', 'κ': 'k',
                'λ': 'l', 'μ': 'm', 'ν': 'n', 'ξ': 'x', 'ο': 'o', 'π': 'p', 'ρ': 'r',
                'σ': 's', 'τ': 't', 'υ': 'y', 'φ': 'f', 'χ': 'x', 'ψ': 'ps', 'ω': 'o',
                'ς': 's', 'έ': 'e', 'ύ': 'y', 'ί': 'i', 'ό': 'o', 'ά': 'a', 'ή': 'i',
                'ώ': 'o', 'ϊ': 'i', 'ΐ': 'i', 'ϋ': 'y',
                // greeklish -> simplified greeklish
                'v': 'b', 'x': 'ks', 'h': 'x', 'y': 'i', 'd': 'nt'
            };
            var alt_query = query;
            for (var k in replace_dict) {
                alt_query = alt_query.replace(new RegExp(k, 'g'), replace_dict[k]);
            }
            if (query != '') {
                $('.ii__match_row').each(function() {
                    if (MatchesTable.extract_text_from_table_row($(this)).indexOf(query) == -1 &&
                            MatchesTable.extract_text_from_table_row($(this)).indexOf(alt_query) == -1) {
                        $(this).addClass('invisible');
                    }
                });
            }

            // show special row when no matches are selected in current filters
            $('table.ii__livescores').each(function() {
                var visible_rows = $(this).find('tr[class^=ii__match_state_]:not(.invisible)').length;
                if (visible_rows == 0) {
                    if ($(this).find('.ii__mf_noresults').length > 0) {
                        $(this).find('.ii__mf_noresults').first().removeClass('invisible');
                    } else {
                        if ($(this).find('tr.ii__headers').length > 0) {
                            $(this).find('tr.ii__headers').after('<tr class="ii__mf_noresults"><td colspan="50">Δεν βρέθηκαν αγώνες</td></tr>');
                        } else {
                            $(this).find('tr').first().before('<tr class="ii__mf_noresults"><td colspan="50">Δεν βρέθηκαν αγώνες</td></tr>');
                        }
                    }
                } else {
                    $(this).find('.ii__mf_noresults').addClass('invisible');
                }
            });


            hideLeagueHeadersWithoutShownMatches();
        },
        toggleFavState: function(clickedElm, mid) {
            // For overlay (Mobile, opened match details)
            if ($(clickedElm).parent().hasClass('ii__overlay__header')) {
                const remAddClass = ['fal', 'fas'];
                const tdElm = $(`.ii__fav_star[data-mid="${mid}"]`);
                MatchesTable.toggle_match_fav(tdElm, mid);
                const starIcon = $(clickedElm).children(':first'),
                    remIndex = starIcon.hasClass('fal') ? 1 : 0;
                starIcon.removeClass(remAddClass[1 - remIndex]).addClass(remAddClass[remIndex]);
            } else { // For td
                MatchesTable.toggle_match_fav(clickedElm, mid);
            }
        },
        applyFavs: function() {
            // Add click handler for stars. Must be here as this function is called after all AJAX calls etc.
            $('.ii__fav_star').off('click').click(
                Star.clickHandler(MatchesTable.toggleFavState));
            var favs = Object.keys(MatchesTable.favs);
            for (var ix in favs) {
                var row = $('.ii__match_row_' + favs[ix]);
                row.addClass('favved');
                row.nextUntil(':not(.ii__attached-to-prev)').addClass('favved');
                row.find('.ii__fav_star:first').children(':first').removeClass('fal').addClass('fas');
            }
        },
        applyOverlayFav: function(matchId) {
            if (Generic.mobile) {
                const overlayHeaderSpan = $('#overlay-fav-star');
                if (Object.keys(MatchesTable.favs).indexOf(`${matchId}`) >= 0) {
                    overlayHeaderSpan.children(':first').removeClass('fal').addClass('fas');
                }

                $('.ii__overlay_fav_star').off('click').click(
                    Star.clickHandler(MatchesTable.toggleFavState));
            }
        },
        applyPins: function() {
            if (!MatchesTable.byleague) {
                return;
            }
            var pinned_block = false;
            var visibility = 0;
            $('table.ii__livescores').find('tr').each(function(i, e) {

                // normal row
                if (!$(e).hasClass('ii__tourheader')) {
                    if (pinned_block) {
                        $(e).addClass('ii__pinned-row');
                    } else {
                        $(e).removeClass('ii__pinned-row');
                    }
                    if (visibility == 1) {
                        $(e).removeClass('ii__collapsed');
                    } else if (visibility == -1) {
                        $(e).addClass('ii__collapsed');
                    }
                    return;
                }

                // tournament header row
                var cl = $(e).attr('class');
                if (!cl) {
                    return;
                }
                cl = cl.split(' ');
                var is_pinned = false;
                for (var ix in cl) {
                    if (Generic.startsWith(cl[ix], 'ii__tour-')) {
                        var league_id = cl[ix].substr(9);
                        if (MatchesTable.leagues_visibility[league_id] == undefined) {
                            visibility = 0;
                        } else if (MatchesTable.leagues_visibility[league_id] == 1) {
                            visibility = 1;
                            $(e).removeClass('ii__collapsed');
                            $(e).find('.ii__tour-collapse').children().first().removeClass('fa-angle-down').addClass('fa-angle-up');
                            $(e).find('.ii__tour-collapse span').hide();
                        } else {
                            visibility = -1;
                            $(e).addClass('ii__collapsed');
                            $(e).find('.ii__tour-collapse').children().first().removeClass('fa-angle-up').addClass('fa-angle-down');
                            $(e).find('.ii__tour-collapse span').show();
                        }
                        if (MatchesTable.pinned[league_id] == 1) {
                            is_pinned = true;
                        }
                    }
                }
                if (is_pinned) {
                    $(e).find('.ii__tour-pin').children().first().removeClass('fal').addClass(`fas ${MatchesTable.pin_clr_class}`);
                    $(e).addClass('ii__pinned-row');
                    if (!Generic.mobile) {
                        $(e).addClass('bgr-greyd').removeClass('bgr-grey');
                    }
                } else {
                    $(e).removeClass('ii__pinned-row');
                    if (!Generic.mobile) {
                        $(e).addClass('bgr-grey').removeClass('bgr-greyd');
                    }
                }

                pinned_block = is_pinned;
            });

            $('table.ii__livescores > tbody > tr').sort(function(a, b) {
                if ($(a).hasClass('ii__pinned-row') && !$(b).hasClass('ii__pinned-row')) {
                    return -1;
                }
                if (!$(a).hasClass('ii__pinned-row') && $(b).hasClass('ii__pinned-row')) {
                    return 1;
                }
                return ($(a).data('sortorder') - $(b).data('sortorder'));
            }).appendTo($('table.ii__livescores'));
        },
        toggle_tour_pin: function(e, tid) {
            if (MatchesTable.pinned == undefined) {
                return;
            }
            if (MatchesTable.pinned[tid] == 1) {
                $(e).children().first().removeClass(`fas ${MatchesTable.pin_clr_class}`).addClass('fal');
                delete MatchesTable.pinned[tid];
                Generic.showFeedback('Αφαιρέθηκε από τις αγαπημένες.');
            } else {
                $(e).children().first().removeClass('fal').addClass(`fas ${MatchesTable.pin_clr_class}`);
                MatchesTable.pinned[tid] = 1;
                Generic.showFeedback('Προστέθηκε στις αγαπημένες.');
            }
            MatchesTable.applyPins();
            if (MatchesTable.pinned[tid] == 1) {
                var rect = $('.ii__tour-' + tid).first()[0].getBoundingClientRect();
                var elemTop = rect.top;
                var elemBottom = rect.bottom;
                var isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
                if (!isVisible) {
                    window.scrollTo(0, $('.ii__tour-' + tid).first().position().top - (Generic.mobile ? 60 : 0));
                }
            }
            Ajax.savePrefPinned(Object.keys(MatchesTable.pinned), MatchesTable.pinnedVersion);
        },
        toggle_tour_collapse: function(e, tid) {
            if (MatchesTable.leagues_visibility == undefined) {
                return;
            }
            if (!Generic.mobile) {
                e = $(e).find('.ii__tour-collapse');
            }
            if ($('.ii__tourheader.ii__tour-' + tid).hasClass('ii__collapsed')) {
                $('.ii__tour-' + tid).removeClass('ii__collapsed');
                $(e).children().first().removeClass('fa-angle-down').addClass('fa-angle-up');
                $(e).find('span').hide();
                MatchesTable.leagues_visibility[tid] = 1;
            } else {
                $('.ii__tour-' + tid).addClass('ii__collapsed');
                $(e).children().first().removeClass('fa-angle-up').addClass('fa-angle-down');
                $(e).find('span').show();
                MatchesTable.leagues_visibility[tid] = -1;
            }
            MatchesTable.applyFavs();
            Ajax.savePrefLeaguesVisibility(MatchesTable.leagues_visibility);
        },
        toggle_match_fav: function(e, mid) {
            var row = $(e).parent();
            if (!row.hasClass('favved')) {
                row.addClass('favved');
                Generic.showFeedback('Προστέθηκε στα επιλεγμένα.');
                if (row.hasClass('ii__attached-to-prev')) {
                    // 2-row scheme: the star is in the 2nd row
                    row.prev().addClass('favved');
                } else {
                    // multi-row scheme: the star is in the 1st row and multiple rows (with .ii__attached-to-prev) may follow
                    row.nextUntil(':not(.ii__attached-to-prev)').addClass('favved');
                }
                $(e).children(':first').removeClass('fal').addClass('fas');
                MatchesTable.favs[mid] = 1;
            } else {
                row.removeClass('favved');
                Generic.showFeedback('Αφαιρέθηκε από τα επιλεγμένα.');
                if (row.hasClass('ii__attached-to-prev')) {
                    // 2-row scheme: the star is in the 2nd row
                    row.prev().removeClass('favved');
                } else {
                    // multi-row scheme: the star is in the 1st row and multiple rows (with .ii__attached-to-prev) may follow
                    row.nextUntil(':not(.ii__attached-to-prev)').removeClass('favved');
                }
                $(e).children(':first').removeClass('fas').addClass('fal');
                delete MatchesTable.favs[mid];
                if ($('.ii__mf_btn_fav').hasClass('active')) {
                    MatchesTable.filterMatches('fav');
                }
            }
            Star.saveStar(mid);
        },
        initGoalSound: function() {
            $('#goal-sound').off('click').click(function(e) {
                if (MatchesTable.goalSoundsMuted) {
                    MatchesTable.goalSoundsMuted = false;
                    Generic.jsCookies.setItem('goal_sound', '1', 3600 * 24 * 365 * 3, '/');
                    $('#goal-sound i').removeClass('fa-volume-mute');
                    $('#goal-sound i').addClass('fa-volume-up');
                    $('#goal-sound').css('background-color', '#1c80c7');  // FIXCSS: use correct color or a class
                } else {
                    MatchesTable.goalSoundsMuted = true;
                    Generic.jsCookies.setItem('goal_sound', '0', 3600 * 24 * 365 * 3, '/');
                    $('#goal-sound i').removeClass('fa-volume-up');
                    $('#goal-sound i').addClass('fa-volume-mute');
                    $('#goal-sound').css('background-color', '');
                }
            });
            MatchesTable.goalSoundsMuted = (!Generic.jsCookies.hasItem('goal_sound') || Generic.jsCookies.getItem('goal_sound') == '0');
            MatchesTable.goalSoundsMuted = !MatchesTable.goalSoundsMuted; // !reverse the state!
            $('#goal-sound').click(); // toggle state (and fix icons etc)

            // load existing goal indicators
            MatchesTable.goalIndicators = {};
            $('table.ii__livescores tr.ii__match_row[data-recent-goal!=no]').each(function() {
                var key = 'g-' + $(this).data('mid') + '-' + $(this).data('recent-goal');
                MatchesTable.goalIndicators[key] = [true, 0]; // [sound played, red marker displayed timestamp]
            });
        },
        goalIndicator: function(matchId) {
            var selector = 'table.ii__livescores tr.ii__match_row[data-recent-goal!=no]';
            if (matchId) {
                selector += '[data-mid=' + matchId + ']';
            }
            var ts = Math.floor(new Date().getTime() / 1000);

            // red marker (GOAL!)
            $(selector).each(function() {
                var key = 'g-' + $(this).data('mid') + '-' + $(this).data('recent-goal');
                if (!(key in MatchesTable.goalIndicators)) {
                    MatchesTable.goalIndicators[key] = [false, ts];
                }
                if (ts - MatchesTable.goalIndicators[key][1] < 180) {
                    $(this).find('.ii__goal_indicator').append('<span class="goal">ΓΚΟΛ</span>');
                }
            });

            // sound
            var play = false;
            if ($('#show_chat_btn.t_btn_active').length != 1) {
                selector += ':visible'; // only check visible rows, unless we are in mobile chat
            }
            $(selector).each(function() {
                var key = 'g-' + $(this).data('mid') + '-' + $(this).data('recent-goal');
                // key should always exist from before
                if (!MatchesTable.goalIndicators[key][0]) {
                    MatchesTable.goalIndicators[key][0] = true;
                    play = true;
                }
            });
            if (play && !MatchesTable.goalSoundsMuted) {
                if ($('#sound_goal1').length) {
                    try {
                        var sound_promise = $('#sound_goal1')[0].play();  // ticker never plays sounds by not defining a #sound_goal1
                        if (sound_promise !== undefined) {
                            sound_promise.then(function() {
                            }).catch(function(error) {
                                // Autoplay was prevented.
                            });
                        }
                    } catch (error) {
                        // Autoplay was prevented.
                    }
                }
            }
        },
        initStarsPinnedAndLeagueToggles: function(favs, pinned = false, leagues_visibility = false) {
            MatchesTable.favs = {1 : 1};
            for (var ix in favs) {
                if (Number.isInteger(favs[ix])) {
                    MatchesTable.favs[favs[ix]] = 1;
                }
            }
            MatchesTable.pinned = {0 : 1};
            if (pinned) {
                for (var iy in pinned) {
                    if (Number.isInteger(Number.parseInt(pinned[iy]))) {
                        MatchesTable.pinned[Number.parseInt(pinned[iy])] = 1;
                    }
                }
            }
            MatchesTable.leagues_visibility = {0 : 1};
            if (leagues_visibility) {
                for (var iz in leagues_visibility) {
                    if (leagues_visibility.hasOwnProperty(iz)) {
                        MatchesTable.leagues_visibility[Number.parseInt(iz)] = Number.parseInt(leagues_visibility[iz]);
                    }
                }
            }
            loadFavsFromCookie();
            MatchesTable.applyFavs();
            MatchesTable.applyPins();
        },
        initFilterButtons: function() {
            $('.ii__mf_btn').off('click').click(function() {
                var filter = $(this).data('filter');
                if (filter != undefined) {
                    MatchesTable.filterMatches(filter);
                }
            });
        },
        initDefaultViewButtons: function() {
            $('.ii__dv_btn').off('click').click(function() {
                var view = $(this).data('view');
                if (view != undefined) {
                    MatchesTable.set_default_view(view);
                }
            });
        },
        applyAllFilters: function() {
            window.Socket && Socket.reapplySocketUpdates && Socket.reapplySocketUpdates();
            MatchesTable.applyFavs();
            MatchesTable.filterMatches(MatchesTable.match_filter);
            MatchesTable.applyPins();
            MatchesTable.goalIndicator();
            Generic.updateTimes();
        },
        init: function(byleague = 0, default_view = -1, favs, pinned, pinned_version, leagues_visibility) {
            MatchesTable.default_view = default_view; // -1: undefined, 0: kouponi, 1: all
            MatchesTable.match_filter = 'all';
            MatchesTable.byleague = byleague;
            MatchesTable.pin_clr_class = Generic.mobile ? 'clr-green' : 'clr-red';
            MatchesTable.init_match_filter(MatchesTable.filterMatches);
            MatchesTable.initFilterButtons();
            MatchesTable.initGoalSound();
            MatchesTable.initDefaultViewButtons();
            const cookiePinnedVersion = Generic.jsCookies.getItem('pinned_leagues_version');
            MatchesTable.pinnedVersion = cookiePinnedVersion > pinned_version ? cookiePinnedVersion : pinned_version;
            MatchesTable.initStarsPinnedAndLeagueToggles(favs, pinned, leagues_visibility);

            var visible_rows = $('table.ii__livescores').find('tr[class^=ii__match_state_]:not(.invisible)').length;
            if ($('.ii__dv_btn').length && visible_rows < COUPON_VISIBLE_ROWS_THRESHOLD && MatchesTable.default_view == 0) {
                // if a)homepage b) too few visible rows c) view is coupon
                // try showing `all` instead of `coupon` without saving the cookie etc
                MatchesTable.default_view = 1;
                $('.ii__dv_btn').removeClass('active blue').prop('disabled', true);
                MatchesTable.filterMatches(MatchesTable.match_filter);
            }
        }
    };
}();

if (typeof module !== 'undefined') {
    module.exports = MatchesTable;
}
